<script>
import API from '../services/api';

const api = new API();

module.exports = {
  template: '#contest-template',
  data: function() {
    return {
      selected: {
        brand: {
          name: 'Valitse'
        }
      },
      dropdown: false,
      thankyou: false,
      rules: false,
      confirm: false
    };
  },
  watch: {
    selected: {
      handler() {
        this.dropdown = false;
      },
      deep: true
    }
  },
  methods: {
    toggleRules: function() {
      if (this.rules) this.rules = false;
      else this.rules = true;
    },
    contestSubmit: function() {
      let self = this;
      if (this.$store.state.contestStatus) {
        api.participateOmaLaakkonenContest().then(res => {
          if (res.status === 1) {
            self.thankyou = true;
            this.$store.state.contestStatus.notParticipated = false;
          }
        });
      }
    },
    toggleDropdown: function() {
      if (this.dropdown) this.dropdown = false;
      else this.dropdown = true;
    }
  },
  computed: {
    brands: function() {
      return this.$store.state.brands;
    },
    status: function() {
      return this.$store.state.contestStatus;
    }
  }
};
</script>